// src/api/demo.js
import { resolveBase } from "./config";

export async function demoRun({
  prompt,
  model = "gpt-4o-mini",
  temperature = 0,
}) {
  const base = resolveBase("demo");
  if (!base) throw new Error("Demo API not configured");

  const body = {
    prompt,
    model,
    temperature,
  };

  const res = await fetch(`${base}/demo/run`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Demo run ${res.status}${text ? `: ${text}` : ""}`);
  }

  return res.json();
}

export async function demoDiff({
  prompt,
  model = "gpt-4o-mini",
  temperature = 0,
}) {
  const base = resolveBase("demo");
  if (!base) throw new Error("Demo API not configured");

  const body = {
    prompt,
    model,
    temperature,
  };

  const res = await fetch(`${base}/demo/diff`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Demo diff ${res.status}${text ? `: ${text}` : ""}`);
  }

  return res.json();
}
